import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=5db8b23b&scoped=true"
import script from "./TasksView.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TasksView.vue?vue&type=style&index=0&id=5db8b23b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8b23b",
  null
  
)

export default component.exports